import { ExtraConfigKey, ConfigName, NameExtraConfig } from './commonPlotDefinitions'
import { TYPE_2D } from './dataExtractors/baseExtractor.js';
import store from '@/store';


//Definitions
const IdentifierComparison='⚯'
const IconSharing = '👥'
const IconIncompleteReport = '📝'
const Individual_Type = 'Individual';
const Comparison_Type = 'Comparison';
const Hyperlink_Type = 'Hyperlink';
const IdentifierHyperlink = '🔗';

const keysRemoveReport = ['media'];
const keysRemoveStudy = [
  'PEAK_POSITION_SINGLE_P_FIT_DISCRETE_BOOL',
  'PEAK_AUC_SINGLE_P_FIT_DISCRETE_BOOL',
  'PEAK_HEIGHT_SINGLE_P_FIT_DISCRETE_BOOL',
  'RAW_GRAPH_BOOL',
  'STATIST_EVAL_1DARRAY',
  'CHRONOMETRIC_BOOL',
  'ERROR_INDEPEND_EVAL',
  'VALUES_INDEPEND_EVAL',
  'STATISTICS_INDEPEND_EVAL',
  'FIT_FLAG_BOOL',
];
const baseMapping = {
  GENERAL__AOF_2DARRAY: `${ConfigName.BaseFeatureCheck}.aoiTimes`,
  FEATURE_SELECTION_1DARRAY: `${ConfigName.BaseFeatureCheck}.features`,
  FEATURE_CHECK_ACTIVATED_BOOL: 'EXTRA__FEATURE_CHECK_ACTIVATED_BOOL',
  LOGX_BOOL: `${ConfigName.BaseAxisProperties}.LOGX_BOOL`,
  LOGY_BOOL: `${ConfigName.BaseAxisProperties}.LOGY_BOOL`,
  X_CONVERT_FACTOR: `${ConfigName.BaseAxisProperties}.X_CONVERT_FACTOR`,
  Y_CONVERT_FACTOR: `${ConfigName.BaseAxisProperties}.Y_CONVERT_FACTOR`,
  [ConfigName.legendStudy]: `${ConfigName.BasePropStudy}.${ConfigName.legendStudy}`,
  [ConfigName.xAxisType]: `${ConfigName.BasePropStudy}.${ConfigName.xAxisType}`,
  [ConfigName.yAxisType]: `${ConfigName.BasePropStudy}.${ConfigName.yAxisType}`,
  [ConfigName.StateTypeStudy]: `${ConfigName.BasePropStudy}.${ConfigName.StateTypeStudy}`,
  [ConfigName.CurrentDirectionReverse]: `${ConfigName.BasePropStudy}.${ConfigName.CurrentDirectionReverse}`,
  SVG_DRAW_CIRCUIT_STRING: `${ConfigName.BasePropStudy}.SVGDrawCircuit`,
  [ConfigName.MappingDiscrete]: `${ConfigName.BasePropStudy}.${ConfigName.MappingDiscrete}`,
  [ConfigName.MappingScanDiscrete]: `${ConfigName.BasePropStudy}.${ConfigName.MappingScanDiscrete}`,
};

const fitMapping = {
  Linear: 'y~x+1',
  Quadratic: 'y~x^2+x+1',
  'Inverse square root': 'y~x^(-1/2)+1',
  'Semilog x': 'y~log10(x)+1',
  'Semilog y': 'log10(y)~x+1',
  'Double log': 'log10(y)~log10(x)+1',
  'Exponential x': 'y~exp(x)+1',
  'Exponential y': 'exp(y)~x+1',
  'Michaelis-Menten': '1/y~1/x+1',
};

const mappingFit = {
  [ConfigName.DeltaFitDiscreteGraph]: {
      name: 'ΔY',
      keys: {
          X1_DELTA_FIT_GRAPH_FLOAT: `${ConfigName.BaseCurveFit}.ΔY.X1`,
          X2_DELTA_FIT_FLOAT: `${ConfigName.BaseCurveFit}.ΔY.X2`,
          MEAN_DELTA_FIT_FLOAT: `${ConfigName.BaseCurveFit}.ΔY.SamplesMean`,
          GENERAL__STATISTICAL_EVAL_DISCRETE_BOOL: 'EXTRA__ΔY.fitStatistics',
          GENERAL__BANDWIDTH_HIST_STATISTICS: `${ConfigName.BaseCurveFit}.ΔY.Statistics.histBW`,
              DELTA_FIT_STANDARD_ADDITION_DISCRETE_BOOL: `${ConfigName.BaseCurveFit}.ΔY.StandardAddition`,
      },
  },
  [ConfigName.SingleFitDiscreteGraph]: {
      name: 'peakPos',
      keys: {
          CENTER_SINGLE_P_FIT_DISCRETE_FLOAT: `${ConfigName.BaseCurveFit}.peakPos.center`,
          WINDOW_SINGLE_P_FIT_DISCRETE_FLOAT: `${ConfigName.BaseCurveFit}.peakPos.window`,
          REVERSE_SINGLE_P_FIT_DISCRETE_BOOL: `${ConfigName.BaseCurveFit}.peakPos.reverseScan`,
          VALLEY_SINGLE_P_FIT_DISCRETE_BOOL: `${ConfigName.BaseCurveFit}.peakPos.valley`,
          HEIGHT_STANDARD_ADDITION_SINGLE_P_FIT_DISCRETE_BOOL: `${ConfigName.BaseCurveFit}.peakPos.StandardAddition`,
          GENERAL__STATISTICAL_EVAL_DISCRETE_BOOL:'EXTRA__peakPos.fitStatistics',
          GENERAL__BANDWIDTH_HIST_STATISTICS: `${ConfigName.BaseCurveFit}.peakPos.Statistics.histBW`,
      },
  },
  [ConfigName.PeakHeightFitDiscreteGraph]: {
      name: 'peakHeight',
      keys: {
          HEIGHT_CENTER_SINGLE_P_FIT_DISCRETE_FLOAT: `${ConfigName.BaseCurveFit}.peakHeight.center`,
          HEIGHT_WINDOW_SINGLE_P_FIT_DISCRETE_FLOAT: `${ConfigName.BaseCurveFit}.peakHeight.window`,
          HEIGHT_REVERSE_SINGLE_P_FIT_DISCRETE_BOOL: `${ConfigName.BaseCurveFit}.peakHeight.reverseScan`,
              HEIGHT_VALLEY_SINGLE_P_FIT_DISCRETE_BOOL: `${ConfigName.BaseCurveFit}.peakHeight.valley`,
              HEIGHT_STANDARD_ADDITION_SINGLE_P_FIT_DISCRETE_BOOL: `${ConfigName.BaseCurveFit}.peakHeight.StandardAddition`,
          GENERAL__STATISTICAL_EVAL_DISCRETE_BOOL:
          'EXTRA__peakHeight.fitStatistics',
          GENERAL__BANDWIDTH_HIST_STATISTICS: `${ConfigName.BaseCurveFit}.peakHeight.Statistics.histBW`,
      },
  },
  [ConfigName.PeakAUCFitDiscreteGraph]: {
      name: 'peakAUC',
      keys: {
          AUC_CENTER_SINGLE_P_FIT_DISCRETE_FLOAT: `${ConfigName.BaseCurveFit}.peakAUC.center`,
          AUC_WINDOW_SINGLE_P_FIT_DISCRETE_FLOAT: `${ConfigName.BaseCurveFit}.peakAUC.window`,
          AUC_REVERSE_SINGLE_P_FIT_DISCRETE_BOOL: `${ConfigName.BaseCurveFit}.peakAUC.reverseScan`,
              AUC_VALLEY_SINGLE_P_FIT_DISCRETE_BOOL: `${ConfigName.BaseCurveFit}.peakAUC.valley`,
              HEIGHT_STANDARD_ADDITION_SINGLE_P_FIT_DISCRETE_BOOL: `${ConfigName.BaseCurveFit}.peakAUC.StandardAddition`,
          GENERAL__STATISTICAL_EVAL_DISCRETE_BOOL:
          'EXTRA__peakAUC.fitStatistics',
          GENERAL__BANDWIDTH_HIST_STATISTICS: `${ConfigName.BaseCurveFit}.peakAUC.Statistics.histBW`,
      },
  },
  [ConfigName.MeanFitDiscreteGraph]: {
      name: 'Ȳ',
      keys: {
          RANGE_MIN_MEAN_FIT_DISCRETE_FLOAT: `${ConfigName.BaseCurveFit}.Ȳ.range.0`, //Hacer un regex de entero para cambiar la llave a Int si es un numero
          RANGE_MAX_MEAN_FIT_DISCRETE_FLOAT: `${ConfigName.BaseCurveFit}.Ȳ.range.1`,
          GENERAL__STATISTICAL_EVAL_DISCRETE_BOOL: 'EXTRA__Ȳ.fitStatistics',
          GENERAL__BANDWIDTH_HIST_STATISTICS: `${ConfigName.BaseCurveFit}.Ȳ.Statistics.histBW`,
              MEAN_FIT_STANDARD_ADDITION_DISCRETE_BOOL: `${ConfigName.BaseCurveFit}.Ȳ.StandardAddition`,
      },
  },
  [ConfigName.StepFitPlot]: {
      name: 'multiȲ',
      keys: {
          GENERAL__STEP_SIZE_FLOAT: `${ConfigName.BaseCurveFit}.multiȲ.stepRange`,
          GENERAL__TIMES_2DARRAY: `${ConfigName.BaseCurveFit}.multiȲ.concTimes`,
          EXTRACTED_VALUES_STATISTICS: `${ConfigName.BaseCurveFit}.multiȲ.showExtractedValues`,
          FIT_STEP_STATISTICAL_BOOL: 'EXTRA__multiȲ.fitStatistics',
          SEPARATED_STATISTICS: `${ConfigName.BaseCurveFit}.multiȲ.SeparateStats`,
          GENERAL__BANDWIDTH_HIST_STATISTICS: `${ConfigName.BaseCurveFit}.multiȲ.Statistics.histBW`,
      },
  },
  [ConfigName.ImpedanceFitDiscreteGraph]: {
      name: 'equivalentCircuit',
      keys: {
          IMPEDANCE_CIRCUIT_STRING: `${ConfigName.BaseCurveFit}.equivalentCircuit.Circuit`,
          INITIAL_GUESS_CIRCUIT_1DARRAY: `${ConfigName.BaseCurveFit}.equivalentCircuit.InitialGuess`,
      },
  },
};

//Functions
function setConfiguration(configuration, key, value) {
  const splitKey = key.split('.');
  if (splitKey.length === 1) {
    configuration[key] = value;
    return;
  }
  const keyValue = splitKey.pop();
  const isArray = /^[0-9]+$/.test(keyValue);
  const lastKey = splitKey[splitKey.length - 1];
  const objectRef = splitKey.reduce((a, b) => {
    if (typeof a[b] === 'undefined') {
      a[b] = isArray && lastKey === b ? [] : {};
    }
    return a[b];
  }, configuration);
  const formatKeyValue = isArray ? parseInt(keyValue) : keyValue;
  objectRef[formatKeyValue] = value;
}

function getAndRemoveConf(configuration, key) {
  const value = configuration[key];
  delete configuration[key];
  return value;
}

function mapKeyValuePair(
  valuePair,
  setValue,
  configStudy,
  generalConfigStudy,
  extraConfigDest,
) {
  for (const [oldKey, newKey] of Object.entries(valuePair)) {
    const isGeneralConfig = /^GENERAL__/.test(oldKey);
    const oldValueConf = isGeneralConfig
      ? generalConfigStudy[oldKey.replace(/^GENERAL__/, '')]
      : configStudy[oldKey];
    if (typeof oldValueConf === 'undefined') continue;
    const isDestGeneralCOnfig = /^EXTRA__/.test(newKey);
    if (setValue) {
      if (isDestGeneralCOnfig)
        setConfiguration(
          extraConfigDest,
          newKey.replace(/^EXTRA__/, ''),
          oldValueConf,
        );
      else setConfiguration(configStudy, newKey, oldValueConf);
    }
    if (!isGeneralConfig) delete configStudy[oldKey];
  }
}

const homogenizeReport = function(report) {
  if (!(ExtraConfigKey in report)) report[ExtraConfigKey] = {};
  if (!('configuration' in report)) report.configuration = {};
  if (!('graphs' in report)) report.graphs = {};
  if (!('type' in report) || report.type === '')
    report['type'] = Individual_Type;

  if (typeof report.files !== 'undefined') {
    for (let j = 0; j < report.files.length; j++) {
      if (typeof report.files[j].type === 'undefined') {
        report.files[j].type = TYPE_2D;
      }
      for (let f = 0; f < report.files[j].extractedData.length; f++) {
        if (typeof report.files[j].extractedData[f].concValue !== 'undefined') {
          report.files[j].extractedData[f].group = report.files[j].extractedData[f].concValue;
          delete report.files[j].extractedData[f].concValue;
        }
      }
    }
  }
  if ('PK' in report.configuration) {
    report.configuration.AC = report.configuration.PK;
    delete report.configuration.PK;
    if ('PK' in report.graphs) {
      report.graphs.AC = report.graphs.PK;
      delete report.graphs.PK;
    }
  }
  if (!('details' in report)) report.details = '';

  for (const keyDel of keysRemoveReport) {
    if (keyDel in report) delete report[keyDel];
  }
  if ('CP' in report.configuration) {
    report.configuration.PC = report.configuration.CP;
    delete report.configuration.CP;
  }
  if ('CA' in report.configuration) {
    report.configuration.AC = report.configuration.CA;
    delete report.configuration.CA;
  }
  if ('proyectID' in report) {
    report.projectId = report.proyectID;
    delete report.proyectID;
  }
  if ('description' in report) {
    if (report.description !== '') {
      if (report.details !== '')
        report.details += '\n' + report.description;
      else report.details = report.description;
    }
    delete report.description;
  }
  if ('purpose' in report) {
    if (report.purpose !== '') {
      if (report.details !== '')
        report.details += '\n' + report.purpose;
      else report.details = report.purpose;
    }
    delete report.purpose;
  }
  if (
    NameExtraConfig.ThirdPartyBackEnd in report[ExtraConfigKey] &&
    report[ExtraConfigKey][NameExtraConfig.ThirdPartyBackEnd] === '/bda/v0/imageRecognition'
    ) {
      report[ExtraConfigKey][NameExtraConfig.ThirdPartyBackEnd] = '/pbda/v0/imageRecognition'
  }

  const generalConfigStudy = report.configuration['GENERAL'] || {};

  //Mapping the new nested structure
  //Fits
  for (const study of Object.keys(report.configuration)) {
    if (study === 'GENERAL') 
      continue;
    const configStudy = report.configuration[study];
    if (!(study in report[ExtraConfigKey]))
      report[ExtraConfigKey][study] = {};
    //Duplicate the boolean for statistical analysis in Discrete
    const discreteStatistics = 'STATISTICAL_EVAL_DISCRETE_BOOL' in configStudy && getAndRemoveConf(configStudy, 'STATISTICAL_EVAL_DISCRETE_BOOL');
    generalConfigStudy['STATISTICAL_EVAL_DISCRETE_BOOL'] = discreteStatistics;
    const histBWStudies =
      'BANDWIDTH_HIST_STATISTICS' in configStudy
        ? getAndRemoveConf(configStudy, 'BANDWIDTH_HIST_STATISTICS')
        : '';
    generalConfigStudy['BANDWIDTH_HIST_STATISTICS'] = histBWStudies;
    if (
      ConfigName.SingleFitDiscreteGraph in configStudy &&
      configStudy[ConfigName.SingleFitDiscreteGraph]
    ) {
      configStudy[ConfigName.PeakHeightFitDiscreteGraph] = false;
      if (configStudy['PEAK_HEIGHT_SINGLE_P_FIT_DISCRETE_BOOL']) {
        configStudy[ConfigName.PeakHeightFitDiscreteGraph] = true;
        configStudy['HEIGHT_CENTER_SINGLE_P_FIT_DISCRETE_FLOAT'] = configStudy['CENTER_SINGLE_P_FIT_DISCRETE_FLOAT'];
        configStudy['HEIGHT_WINDOW_SINGLE_P_FIT_DISCRETE_FLOAT'] = configStudy['WINDOW_SINGLE_P_FIT_DISCRETE_FLOAT'];
        configStudy['HEIGHT_REVERSE_SINGLE_P_FIT_DISCRETE_BOOL'] = configStudy['REVERSE_SINGLE_P_FIT_DISCRETE_BOOL'];
      }
      configStudy[ConfigName.PeakAUCFitDiscreteGraph] = false;
      if (configStudy['PEAK_AUC_SINGLE_P_FIT_DISCRETE_BOOL']) {
        configStudy[ConfigName.PeakAUCFitDiscreteGraph] = true;
        configStudy['AUC_CENTER_SINGLE_P_FIT_DISCRETE_FLOAT'] = configStudy['CENTER_SINGLE_P_FIT_DISCRETE_FLOAT'];
        configStudy['AUC_WINDOW_SINGLE_P_FIT_DISCRETE_FLOAT'] = configStudy['WINDOW_SINGLE_P_FIT_DISCRETE_FLOAT'];
        configStudy['AUC_REVERSE_SINGLE_P_FIT_DISCRETE_BOOL'] = configStudy['REVERSE_SINGLE_P_FIT_DISCRETE_BOOL'];
      }
      if (!configStudy['PEAK_POSITION_SINGLE_P_FIT_DISCRETE_BOOL']) {
        delete configStudy['CENTER_SINGLE_P_FIT_DISCRETE_FLOAT'];
        delete configStudy['WINDOW_SINGLE_P_FIT_DISCRETE_FLOAT'];
        delete configStudy['REVERSE_SINGLE_P_FIT_DISCRETE_BOOL'];
        configStudy[ConfigName.SingleFitDiscreteGraph] = false;
      }
    }

    // Map all the old fits
    for (const [fit, parameters] of Object.entries(mappingFit)) {
      if (fit in configStudy) {
        report[ExtraConfigKey][study][fit] = configStudy[fit];
        mapKeyValuePair(
          parameters.keys,
          configStudy[fit],
          configStudy,
          generalConfigStudy,
          report[ExtraConfigKey][study],
        );

        //Add the Fit formula value
        if (configStudy[fit]
            && 'MODEL_TYPE' in configStudy
            && configStudy['MODEL_TYPE'] in fitMapping
        )
          setConfiguration(configStudy, `${ConfigName.BaseCurveFit}.${parameters.name}.Model`, fitMapping[configStudy['MODEL_TYPE']]);
        delete configStudy[fit];
      }
    }
    //Common values mapping
    mapKeyValuePair(
      baseMapping,
      true,
      configStudy,
      generalConfigStudy,
      report[ExtraConfigKey][study],
    );

    //Add Baseline and range to preprocessing
    const rangeKeys = [
      'RANGE_MIN_Y_FLOAT',
      'RANGE_MAX_Y_FLOAT',
      'RANGE_MIN_FLOAT',
      'RANGE_MAX_FLOAT',
    ];
    if (typeof(configStudy[ConfigName.PreprocessingList]) === 'undefined' && rangeKeys.some((k) => k in configStudy && configStudy[k] !== '')) {
        configStudy[ConfigName.PreprocessingList] = ['Crop'];
    }
    if ('BASELINE_BOOL' in configStudy) {
      const baselineReq = getAndRemoveConf(configStudy, 'BASELINE_BOOL');
      if (baselineReq) {
        if (typeof configStudy[ConfigName.PreprocessingList] === 'undefined')
          configStudy[ConfigName.PreprocessingList] = ['Baseline'];
        else if (!configStudy[ConfigName.PreprocessingList].includes('Baseline'))
          configStudy[ConfigName.PreprocessingList].unshift('Baseline');
      }
    }

    //Remove copied variables
    if ('MODEL_TYPE' in configStudy) delete configStudy['MODEL_TYPE'];
    delete generalConfigStudy['STATISTICAL_EVAL_DISCRETE_BOOL'];
    delete generalConfigStudy['BANDWIDTH_HIST_STATISTICS'];

    //Remove old keys from studies
    for (const keyRem of keysRemoveStudy) {
      if (keyRem in configStudy) delete configStudy[keyRem];
    }
  }
  if ('AOF_2DARRAY' in generalConfigStudy)
    delete generalConfigStudy['AOF_2DARRAY'];
  if ('TIMES_2DARRAY' in generalConfigStudy)
    delete generalConfigStudy['TIMES_2DARRAY'];
  if ('STEP_SIZE_FLOAT' in generalConfigStudy)
    delete generalConfigStudy['STEP_SIZE_FLOAT'];

  //Move the generalConfig
  for (const [key, value] of Object.entries(generalConfigStudy))
    report[ExtraConfigKey][key] = value;
  if ('GENERAL' in report.configuration)
    delete report.configuration['GENERAL'];
}


/**
 * Retrieves linked report as json objects for a given report.
 *
 * @param {Object} report - The report object containing details for which linked reports are to be retrieved.
 * @returns {Promise<Array>} A promise that resolves to an array of linked report json objects.
 */
async function getLinkedReportObj(report, alreadyLinkedReports = [], parentCountLinkRepo = 0) {
  let linkedReportsObjt = [];
  alreadyLinkedReports.push(report.id);
  let countLinkRepo = 1;
  for (const reportId of (report.reportLinked || [])) {
    if (alreadyLinkedReports.includes(reportId)) {
      continue;
    }
    //TODO: remove dependency on store, this shall we masked on a function that could work on front-end and back-end
    const linkedReport = await store.dispatch('retrieveReportObjtReportViewer', {
      reportId,
      projectId: report.projectId,
      clusterId: store.getters.getClusterURLReportViewer,
      nameStr: `linked report ${parentCountLinkRepo > 0 ? parentCountLinkRepo + '.' : ''}${countLinkRepo}`
    });
    countLinkRepo++;
    if (linkedReport === null || typeof (linkedReport) === 'undefined')
      continue;
    linkedReportsObjt.push(linkedReport);
    const indirectLinkedReports = await getLinkedReportObj(linkedReport, alreadyLinkedReports, countLinkRepo - 1);
    linkedReportsObjt.push(...indirectLinkedReports);
  }
  return linkedReportsObjt;
}

/**
 * Retrieves all reports associated to the given report, i.e., report + linked reports
 *
 * @param {Object} report - The report object containing details for which reports associated will be retrieved
 * @returns {Promise<Array>} A promise that resolves to an array associated reports
 */
async function getAllReportObj(report) {
  const linkedReportsObjt = await getLinkedReportObj(report);
  return [report, ...linkedReportsObjt]
}

async function getScanFilesList(report) {
  const scans = [];
  for(const r of await getAllReportObj(report)){
    if (typeof(r[ExtraConfigKey]) === 'undefined' || typeof r[ExtraConfigKey][NameExtraConfig.ScansFiles] === 'undefined')
      continue;
    for (const scan of Object.keys(r[ExtraConfigKey][NameExtraConfig.ScansFiles])) {
      scans.push({ text: scan, value: scan });
    }
  }
  return scans;
}

export {
    IdentifierComparison,
    IconSharing,
    IconIncompleteReport,
    Individual_Type,
    Comparison_Type,
    Hyperlink_Type,
    IdentifierHyperlink,
    homogenizeReport,
    getScanFilesList,
    getLinkedReportObj,
    mappingFit,
}